import React, { Component } from 'react';
import classNames from 'classnames';
import Icon from '../icon/Icon';
import './InfoTooltip.css';

export default class InfoTooltip extends Component {
	render() {
		const { text, size, className } = this.props;
		const classes = classNames('g-info-tooltip', className);

		return (
			<div className={classes}>
				<Icon name="info-outline" size={size || 'x-small'} />
				<div className="g-info-tooltip-text">{text}</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/infoTooltip/InfoTooltip.jsx